import { render, staticRenderFns } from "./ClientLanguages.vue?vue&type=template&id=b25979ec"
import script from "./ClientLanguages.vue?vue&type=script&lang=js"
export * from "./ClientLanguages.vue?vue&type=script&lang=js"
import style0 from "./ClientLanguages.vue?vue&type=style&index=0&id=b25979ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports